(() => {
  if (window._thkWhatsAppCartHandlerBound) return;
  window._thkWhatsAppCartHandlerBound = true;

  document.addEventListener('click', async (event) => {
    const target = event.target;
    const button = target instanceof Element
      ? target.closest('#whatsapp-cart-checkout-btn, .whatsapp-checkout-btn, [data-whatsapp-checkout]')
      : null;

    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    if (button.disabled || button.getAttribute('aria-disabled') === 'true') return;

    button.disabled = true;
    button.style.opacity = '0.7';

    try {
      const response = await fetch('/cart.js', {
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
      });

      if (!response.ok) throw new Error('Failed to fetch cart');

      const cart = await response.json();

      if (!cart.items?.length) {
        alert('Your cart is empty.');
        return;
      }

      const whatsappNumber = String(button.getAttribute('data-whatsapp-number') || '').replace(/\D/g, '');
      if (!whatsappNumber) throw new Error('WhatsApp phone number is missing');

      let message = 'Hi! I would like to place an order:\n\n';

      cart.items.forEach((item) => {
        let itemLine = `- ${item.quantity}x ${item.product_title}`;
        let variant = '';

        if (item.options_with_values?.length) {
          const sizeOption = item.options_with_values.find((option) => /size/i.test(option.name));
          if (sizeOption?.value && sizeOption.value !== 'Default Title') variant = sizeOption.value;
        }
        if (!variant && item.variant_title && item.variant_title !== 'Default Title') variant = item.variant_title;
        if (variant) itemLine += ` (Size: ${variant})`;

        if (item.properties && typeof item.properties === 'object') {
          const properties = Object.entries(item.properties)
            .filter(([key, value]) => !key.startsWith('_') && value)
            .map(([key, value]) => `${key}: ${value}`);
          if (properties.length) itemLine += ` [${properties.join(', ')}]`;
        }

        const linePrice = item.final_line_price ?? item.line_price;
        if (linePrice != null) itemLine += ` - ₹${Math.round(linePrice / 100).toLocaleString('en-IN')}`;
        message += `${itemLine}\n`;
      });

      message += `\nTotal Cart Value: ₹${Math.round(cart.total_price / 100).toLocaleString('en-IN')}`;
      const whatsappUrl = `https://wa.me/${encodeURIComponent(whatsappNumber)}?text=${encodeURIComponent(message)}`;

      if (/Android|iPhone|iPad|iPod/i.test(navigator.userAgent)) {
        window.location.href = whatsappUrl;
      } else {
        const newTab = window.open(whatsappUrl, '_blank', 'noopener,noreferrer');
        if (!newTab || newTab.closed || typeof newTab.closed === 'undefined') window.location.href = whatsappUrl;
      }
    } catch (error) {
      console.error('WhatsApp Cart Checkout error:', error);
      alert('Could not open WhatsApp checkout. Please try again.');
    } finally {
      button.disabled = false;
      button.style.opacity = '1';
    }
  }, true);
})();
